// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.num-balance[data-v-ce863fa6]{\n  color: #488CE8;\n  font-size: 24px;\n  font-weight: 600;\n}\n.mb-12[data-v-ce863fa6]{\n  margin-bottom: 12px;\n}\n.mt-12[data-v-ce863fa6]{\n  margin-top: 14px\n}\n", ""]);
// Exports
module.exports = exports;
